import React from 'react'

function Header() {
    return (
        <div className="ui menu">
            <div className="ui container center">
                <h2>KaratShop</h2>
            </div>
        </div>
    )
}

export default Header
